import type { ReactNode } from 'react';

import type { CompareConfig } from '@/types/CompareConfig';

import CompareButton from './CompareButton';
import ThreeDotsMenu from './ThreeDotsMenu';

type CarTypeMenuProps = {
  menuOptions?: ReactNode[];
  compareConfig?: CompareConfig;
};

const CarTileMenu = ({ menuOptions, compareConfig }: CarTypeMenuProps) => {
  if (menuOptions && !compareConfig?.isCompareMode) {
    return <ThreeDotsMenu menuOptions={menuOptions} />;
  }

  if (compareConfig && compareConfig.isCompareMode) {
    return (
      <CompareButton
        isSelected={compareConfig.isSelected}
        onClick={compareConfig.onClick}
      />
    );
  }

  return null;
};

export default CarTileMenu;
